import { Typography, Box, Grid, FormControlLabel, Switch } from "@mui/material";
import { useAppSelector } from "../../../../../../hooks/store-hooks";
import { HeaderFiltro } from "../header-filtro";
import { ClasseSocialKeys, IClasseSocial } from "../../../../../../../application/models";
import { useProjetosService } from "../../../../../../../use-cases/geo-veles";

export const classeSocialKeyToLabel = (classeSocialKey: IClasseSocial) => {
    switch (classeSocialKey) {
        case 'A':
            return 'Classe A';
        case 'B':
            return 'Classe B';
        case 'C':
            return 'Classe C';
        case 'D':
            return 'Classe D';
        case 'E':
            return 'Classe E';
        default:
            return 'Não definido';
    }
};

export const FiltroClasseSocial = () => {
    // State
    const { filtrosSelecionados } = useAppSelector((state) => state.projetos);
    // Hook
    const { addClasseSocialFilter, removeClasseSocialFilter } = useProjetosService();

    return (
        <>
            <HeaderFiltro 
                titulo="Classe Social"
                descricao={
                    <>
                        <Typography style={{ marginBottom: '10px' }}>
                            Esta opção permite buscar pessoas pela classe social, podendo não selecionar nenhuma ou até mesmo todas.
                        </Typography>
                        <Typography>
                            Caso nenhuma opção seja selecionada, consideraremos todas.
                        </Typography>
                    </>
                }
            />

            <Box p={3} style={{ marginTop: '10px' }}>
                <Grid container spacing={3}>
                    {ClasseSocialKeys.map((classeSocial) => (
                        <Grid item xs={4} key={classeSocial}> {/* Adicionando key única */}
                            <FormControlLabel
                                label={classeSocialKeyToLabel(classeSocial).toUpperCase()}
                                control={
                                    <Switch
                                        checked={filtrosSelecionados?.classeSocial?.includes(classeSocial) ?? false}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                addClasseSocialFilter(classeSocial);
                                            } else {
                                                removeClasseSocialFilter(classeSocial);
                                            }
                                        }}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                    />
                                }
                            />
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </>
    );
};
